<template>
    <div>
        <!--<nav-back :dataTit="'企业列表'"></nav-back>-->
        <!--<def-hn></def-hn>-->
        <div class="index-break">
            <breadcrumb :list="breadList"
                        :rightShow="true"
                        :top_url_name="activityView.top_url_name"
                        :top_url="activityView.top_url"
            ></breadcrumb>
        </div>
        <div class="banner-all" :style="'height: ' + activityView.company_banner_height + 'px'">
          <img @click="goUrl(item)" :src="activityView.company_banner" class="banner-img"/>
        </div>
        <div class="cont-width">
            <div class="search-container">
                <input class="inp" placeholder="请输入企业名称" v-model="keyword"/>
                <div class="bont1" @click="goSearch">搜索</div>
                <div class="bont" @click="exShow = true">我要参展</div>
            </div>
            <div class="ul-bonts" v-if="activityView.c_status !== 0">
                <div @click="selectChange(1)"  :class="{'ul-bonts-left': company_type === 1}">3D展厅</div>
                <div @click="selectChange(2)" :class="{'ul-bonts-right': company_type === 2}">标准展厅</div>
            </div>
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
                <ul class="company-ul">
                    <li class="company-li" v-for="(item, index) in list" :key="index" @click="goView(item)">
                        <div class="company-li-img">
                            <img :src="item.logo"/>
                        </div>
                        <div class="company-msg">
                            <div class="title">
                                <div>{{item.title}}</div>
                            </div>
                            <div class="nums">
                                <div>
                                    <span class="iconfont icon-3"></span>
                                    <span>{{item.contact}}</span>
                                </div>
                                <div>
                                    <span class="iconfont icon-kaiyanjing"></span>
                                    <span>{{item.views}}</span>
                                </div>
                            </div>
                        </div>
                        <img class="company-icon" src="../../assets/right.png"/>
                    </li>
                </ul>
                <div style="height: 50px"></div>
            </mt-loadmore>
        </div>
        <div class="no-msg" v-if="nomsgShow && list.length <= 0">暂无数据</div>
        <div class="layer-bor" v-if="exShow">
            <div class="layer-cont">
                <span class="layer-icon" @click="exShow = false">×</span>
                <span class="clear"></span>
                <div class="layer-title">
                    <p>{{activityView.title}}</p>
                    参展信息填写
                </div>
                <div class="layer-tips">工作人员联系方式：<br/>{{activityView.service_phone}}</div>
              <div style="margin-top: 0">
                <div style="font-size:14px">企业编码 <span style="color:#ff0000">(可通过企业编码提取已填写的信息)</span></div>
                <div class="bonts" style="margin-top: 5px">
                  <el-input v-model="searchCode"
                            size="small"
                            style="padding-right:10px"
                            placeholder="请输入企业编码,没有可不填写"
                  >
                  </el-input>
                  <el-button @click="getInfo" size="small">提取信息</el-button>
                </div>

              </div>
              <div style="font-size:14px; text-align: left">
               当前状态:
                <span :style="{color: statusColorArr[postData.status] ? statusColorArr[postData.status] : '#999999'}">
                  {{statusArr[postData.status] ? statusArr[postData.status]:'未申请参展'}}
                </span>
              </div>
                <div class="inp-bor" >
                    <div class="inp-bor-title" style="padding-bottom:5px">企业名称<span>*</span></div>
                    <el-input size="small"  v-model="postData.title" placeholder="请输入企业名称"/>
                </div>
                <div class="inp-bor">
                    <div class="inp-bor-title">参展类型<span>*</span></div>
                    <el-select v-model="postData.c_type" placeholder="请选择参展类型" size="mini" class="inp-bor-select">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <!--<input class="inp-bor-def" v-model="postData.c_type" placeholder="请输入展厅类型"/>-->
                </div>
                <div class="inp-bor">
                    <div class="inp-bor-title">联系方式(联系人+电话)<span>*</span></div>
                    <el-input size="small" class="inp-bor-def" v-model="postData.contact" placeholder="请输入联系方式"/>
                </div>
                <div class="inp-bor">
                    <div class="inp-bor-title">企业介绍<span>*</span></div>
                    <el-input size="small"
                              type="textarea"
                              class="inp-bor-def"
                              v-model="postData.content"
                              placeholder="请输入企业介绍"
                              style="margin-bottom: 10px"
                    />
                </div>
                <div class="inp-bor" >
                    <div class="inp-bor-title" style="margin-bottom: 8px">企业LOGO(像素大小为86x86)<span>*</span></div>
                    <el-upload
                            class="avatar-uploader"
                            action="https://showapi.xyxun.top/Uploaders/uploader"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar" >
                        <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #999"></i>
                    </el-upload>
                </div>
                <div class="inp-bor">
                    <div class="inp-bor-title" style="margin-bottom: 8px">参展产品<span>*</span></div>
                  <el-input size="small"
                            type="textarea"
                            class="inp-bor-def"
                            v-model="productText"
                            style="margin-bottom: 10px" placeholder="请输入参展产品描述"/>
                    <el-upload
                            class="upload-demo"
                            action="https://showapi.xyxun.top/Uploaders/uploader"
                            :on-remove="handleRemove"
                            multiple
                            :limit="10"
                            :on-exceed="handleExceed"
                            :before-upload="beforeAvatarUpload1"
                            :on-success="handleAvatarSuccess1"
                            :file-list="productList">
                        <el-button size="small" type="info">上传图片 / 视频</el-button>
                        <div slot="tip" class="el-upload__tip">图片支持2M以内jpg/png/jpeg格式；视频支持100M以内mp4格式；</div>
                    </el-upload>
                </div>
                <div class="inp-bor">
                    <div class="inp-bor-title" style="margin-bottom: 8px">资料下载</div>
                    <el-upload
                            class="upload-demo"
                            action="https://showapi.xyxun.top/Uploaders/uploader"
                            :on-remove="handleRemove2"
                            multiple
                            :limit="10"
                            :on-exceed="handleExceed2"
                            :before-upload="beforeAvatarUpload1"
                            :on-success="handleAvatarSuccess2"
                            :file-list="fileList">
                        <el-button size="small" type="info">可上传图片/视频/文件</el-button>
                        <div slot="tip" class="el-upload__tip">图片支持2M以内jpg/png/jpg格式；视频支持100M以内mp4格式；文件支持100M以内pdf/ppt/doc格式</div>
                    </el-upload>
                </div>
              <div v-if="code" >
                <div style="margin: 15px 0 0 0; font-size:14px">
                  企业编码<span style="color:#ff0000">(请保留好企业编码，用于后续查询审核状态、更改企业信息)</span></div>
                <div class="bonts" style="margin-top: 5px">
                  <el-input v-model="code"
                            size="small"
                            style="padding-right:10px"
                            readonly
                            ref="copyInput"
                  >
                  </el-input>
                  <el-button @click="copyCode" size="small" >复制企业编码</el-button>
                </div>
              </div>
                <div class="bonts">
                    <el-button type="warning" @click="preview(postData.id)" v-if="postData.status>=0">预览</el-button>
                    <el-button type="primary" @click="goSure" :disabled="btnDisabled">提交</el-button>
                    <el-button @click="exShow = false">关闭</el-button>
                </div>
            </div>
        </div>
      <img class="back-bont" @click="goLive" v-if="activityView.bottom_url_img" :src="activityView.bottom_url_img"/>
        <img class="back-bont" @click="goLive" v-else src="../../assets/1.jpg"/>
      <el-dialog
        title="系统提示"
        :visible.sync="dialogVisible"
        width="50%"
        >
        <span>您的参展信息已提交，请耐心等候工作人员审核。</span>
        <div style="padding: 10px 0;">
          您的企业信息编码是：<span style="color: red;font-weight: bold;">{{code}}</span>，该编码用于后续查询审核状态，更改企业信息，请妥善保存。
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleReEdit()">取消，我要修改信息</el-button>
          <el-button type="primary" @click="dialogVisible = false">确定，编码已保存好</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  import NavBack from "../public/navBack"
  import DefHn from "../public/defHn"
  import config from '../../common/config.js'
  import msgbox from '../../common/msgbox'
  import breadcrumb from "../public/breadcrumb"
  import VueFileUpload from 'vue-file-upload';
  let wx = require('weixin-js-sdk')
  export default {
    name: "company",
    components: {
      NavBack, DefHn, breadcrumb, VueFileUpload},
    data () {
      return {
        dialogVisible: false,
        btnDisabled: false,
        statusArr: ['待审', '驳回', '上架', '下架'],
        statusColorArr: ['', '#ff0000', '#00ff00', '#ff0000'],
        code: '',
        searchCode: '',
        list: [],
        pages: 1,
        allLoaded: false,
        nomsgShow: false,
        keyword: '',
        activityView: {},
        breadList: [
          {
            name: '首页',
            url: '/'
          },
          {
            name: '企业列表',
            url: ''
          }
        ],
        company_type: 1,
        exShow: false,
        imageUrl: '',
        fileList: [],
        productList: [],
        dataList: [],
        postData: {
          title: '',
          c_type: '',
          logo: '',
          contact: '',
          content: '',
          product: [],
          file: []
        },
        productText: '',
        options: [{
          value: '3D展厅',
          label: '3D展厅'
        }, {
          value: '标准展厅',
          label: '标准展厅'
        }]
      }
    },
    created () {
      // WeixinJSBridge.call('hideOptionMenu')
      this.getView()
    },
    // watch: {
    //   company_type () {
    //     this.pages = 1
    //     this.list = []
    //     this.getAll()
    //   }
    // },
    methods: {
      handleReEdit(){
        this.btnDisabled = false
        this.dialogVisible = false
        this.searchCode = this.code
        this.getInfo()
      },
      handleDisabledBtn(){
        this.btnDisabled = true
        // setTimeout(()=>{
        //   this.btnDisabled = false
        // }, 5000)
      },
      getInfo(){
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'collectInfos/getinfo',
          data: {
            searchCode: that.searchCode
          },
          cbSuccess(data) {
            that.code = !data.memo.code ? '' : data.memo.code
            that.postData = data.memo
            that.imageUrl = data.memo.logo
            that.fileList = []
            that.productList = []
            let files = data.memo.file,
              products = data.memo.product
            for(let i in files){
              that.fileList.push({
                type: files[i].type,
                value: files[i].value,
                name: files[i].name?files[i].name: files[i].value,
                url: files[i].value
              })
            }
            for(let i in products){
              if(products[i].type === 'text'){
                that.productText = products[i].value
                continue
              }
              that.productList.push({
                type: products[i].type,
                value: products[i].value,
                name: products[i].name? products[i].name: products[i].value,
                url: products[i].value
              })
            }
            //console.log(data.memo)
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 3000
            })
          }
        })
      },
      preview(aid) {
        let routeData = this.$router.resolve({
          path: '/company/preview',
          query: {
            eid: this.$route.query.eid,
            aid: aid
          }
        })
        window.open(routeData.href)
        // this.$router.push({
        //   path: '/company/preview',
        //   query: {
        //     eid: this.$route.query.eid,
        //     aid: aid
        //   }
        // })
      },
      copyCode() {
        this.$refs.copyInput.select()
        document.execCommand("copy")
        Toast({
          message: '复制成功',
          duration: 3000
        })
      },
      goUrl (i) {
        if (i.link !== '') {
          window.open(i.link)
        }
      },
      goLive () {
        window.open(this.activityView.bottom_url)
      },
      goSure () {
        let that = this
        let adata = [
          {
            val: this.postData.title,
            rules: {
              required: {
                msg: msgbox.get('请输入企业名称')
              }
            }
          },
          {
            val: this.postData.c_type,
            rules: {
              required: {
                msg: msgbox.get('请选择展厅类型')
              }
            }
          },
          {
            val: this.postData.contact,
            rules: {
              required: {
                msg: msgbox.get('请输入联系方式')
              }
            }
          },
          {
            val: this.postData.content,
            rules: {
              required: {
                msg: msgbox.get('请输入企业介绍')
              }
            }
          },
          {
            val: this.postData.logo,
            rules: {
              required: {
                msg: msgbox.get('请上传LOGO')
              }
            }
          },
          {
            val: this.productText,
            rules: {
              required: {
                msg: msgbox.get('请输入参展产品描述')
              }
            }
          }
        ]
        let ressss = this.$g.verify.check(adata)
        if (ressss !== true) {
          Toast({
            message: ressss,
            duration: 5000
          })
          return false
        }
        if (this.productList.length <= 0) {
          Toast({
            message: '请上传产品图片 / 视频',
            duration: 5000
          })
          return false
        }

        this.postData.product = []
        let obj = {
          type: 'text',
          value: this.productText
        }
        this.postData.product.push(obj)
        for (let i in this.productList) {
          let obj1 = {}
          if(!!this.productList[i].type){
            obj1 = {
              type: that.productList[i].type,
              value: that.productList[i].value,
              name: that.productList[i].name,
            }
          } else {
            obj1 = {
              type: that.productList[i].raw.type.indexOf('video') > -1 ? 'video' : 'img',
              value: that.productList[i].response.memo.fullName,
              name: that.productList[i].response.memo.oriName
            }
          }

          that.postData.product.push(obj1)
        }
        that.postData.file = []
        if (this.dataList.length > 0) {
          for (let i in this.dataList) {
            let obj2 = {}
            if(!!that.dataList[i].type){
              obj2 = {
                type: that.dataList[i].type,
                value: that.dataList[i].value,
                name: that.dataList[i].name
              }
            } else {
              obj2 = {
                type: that.dataList[i].raw.type.indexOf('video') > -1 ? 'video' : 'img',
                value: that.dataList[i].response.memo.fullName,
                name: that.dataList[i].response.memo.oriName
              }
            }

            that.postData.file.push(obj2)
          }
        }
        this.postData['event_id'] = this.activityView.id
        this.handleDisabledBtn()
        this.$g.ajax({
          method: 'post',
          path: 'collectInfos/add',
          data: this.postData,
          cbSuccess(data) {
            // that.$alert('您的参展信息已提交，请耐心等候工作人员审核', '系统消息', {
            //   confirmButtonText: '确定',
            //   callback: action => {
            //     that.btnDisabled = false
            //   }
            // })

            that.code = data.memo.code
            that.postData['status'] = 0
            that.postData['id'] = data.memo.aid
            that.dialogVisible = true
            // that.exShow = false
            // that.productList = []
            // that.dataList = []
            // that.fileList = []
            // that.productText = ''
            // that.imageUrl = ''
            // that.postData = {
            //   title: '',
            //   c_type: '',
            //   logo: '',
            //   contact: '',
            //   content: '',
            //   product: [],
            //   file: []
            // }
          },
          cbError(data) {
            that.btnDisabled = false
            let msg = data.msg
            Toast({
              message: msg,
              duration: 3000
            })
          }
        })
        console.log(this.postData)
      },
      //资料下载
      handleAvatarSuccess2 (response, file, fileList) {

        this.dataList = fileList
      },
      handleRemove2(file, fileList) {
        this.dataList = fileList
      },
      handleExceed2(files, fileList) {
        this.$message.error(`当前限制选择 10 个文件`);
      },
      //资料下载End
      //参展产品
      handleAvatarSuccess1 (response, file, fileList) {
        this.productList = []
        this.productList = fileList
      },
      handleRemove(file, fileList) {
        this.productList = []
        this.productList = fileList
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制选择 10 个文件`);
      },
      beforeAvatarUpload1(file) {
        console.log(file)
        const isLt100M = file.size / 1024 / 1024 < 100
        const isLt2M = file.size / 1024 / 1024 < 2
        const isJPEG = file.type === 'image/jpeg'
        const isJPG = file.type === 'image/jpg'
        const isPNG = file.type === 'image/png'
        const isGIF = file.type === 'image/gif'
        const isVideo = file.type.indexOf('video') > -1
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
          'application/vnd.ms-powerpoint',
          '.doc',
          '.docx',
          '.pdf',
          '.ppt',
          '.pptx',
          'application/pdf']
        const type = file.type !== '' ? file.type : file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        const isRightType = allowedTypes.indexOf(type) >= 0
        if (isJPEG || isJPG || isPNG || isGIF) {
          if (!isLt2M) {
            this.$message({
              showClose: true,
              type: 'error',
              message: '上传图片大小不能超过2M!'
            })
            return false
          }
        }
        if (!isLt100M) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '上传文件大小不能超过100M!'
          })
        }
        if (!isJPG && !isJPEG && !isPNG && !isGIF && !isVideo && !isRightType) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '上传文件只能是 JPG/JPEG/PNG/GIF/VIDEO/DOC/PDF 格式!'
          })
        }
        return isLt100M && (isJPEG || isJPG || isPNG || isGIF || isVideo || isRightType)
      },
      //参展展品end
      //logo
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.postData.logo = file.response.memo.fullName
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        const isJPEG = file.type === 'image/jpeg'
        const isJPG = file.type === 'image/jpg'
        const isPNG = file.type === 'image/png'
        const isGIF = file.type === 'image/gif'
        if (!isLt2M) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '上传logo大小不能超过10M!'
          })
        }
        if (!isJPG && !isJPEG && !isPNG && !isGIF) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '上传logo只能是 JPG/JPEG/PNG/GIF 格式!'
          })
        }
        return isLt2M && (isJPEG || isJPG || isPNG || isGIF)
      },
      //logo end
      getView () {
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'events/view',
          data: {
            id: this.$route.query.eid
          },
          cbSuccess(data) {
            if(data.memo.enabled === 0){
              that.$router.push({path: '/end'})
              return false
            }
            that.activityView = data.memo
            console.log(data.memo)
            document.title = that.activityView.title
            that.breadList[0].url = '/?id=' + that.activityView.id
            // sessionStorage.setItem('activityView', JSON.stringify(data.memo))
            that.getAll()
            that.goyanzheng()
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      goView (i) {
        let activityView = this.activityView
        this.$router.push('/company/view?eid=' + activityView.id + '&aid=' + i.id)
      },
      selectChange (num) {
        this.company_type = num
        this.list = []
        this.pages = 1
        this.getAll()
      },
      goSearch () {
        this.company_type = ''
        this.list = []
        this.pages = 1
        this.getAll()
      },
      getAll () {
        console.log(this.pages)
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'eventCompanies/getList',
          data: {
            event_id: this.$route.query.eid,
            keyword: this.keyword,
            page: this.pages,
            company_type: this.activityView.c_status === 0 ? '' : this.company_type
          },
          cbSuccess(data) {
            that.$refs.loadmore.onTopLoaded()
            // that.allLoaded = true
            that.$refs.loadmore.onBottomLoaded();
            for (let i in data.memo.list) {
              that.list.push(data.memo.list[i])
            }
            console.log(that.list)
            if (that.list.length <= 0) {
              that.nomsgShow = true
            }
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      loadTop () {
        this.list = []
        this.pages = 1
        this.getAll()
      },
      loadBottom () {
        this.pages++
        this.getAll()
      },
      goBack () {
        // this.$route.query.eid
        this.$router.push({
          path: '/',
          query: {
            id: this.$route.query.eid
          }
        })
      },
      goyanzheng () {
        let that = this
        this.$g.ajax({
          path: 'uploaders/jssdksign',
          method: 'post',
          data: {
            url: location.href.split('#')[0]
          },
          cbSuccess (data) {
            that.begin(data.memo.nonceStr, data.memo.signature, data.memo.timestamp)
          },
          cbError (error) {
            let msg = error.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1500
            })
          }
        })
      },
      begin (nonceStr, signature, timestamp) {
        let that = this
        let shareWxLink = config.host + 'company/index?eid=' + this.activityView.id
        console.log(shareWxLink)
        wx.config({
          debug: false,
          appId: 'wx97dae6033b09528a',
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '线上展厅 | ' + that.activityView.title, // 分享标题
            desc: that.activityView.share_text !== null ? that.activityView.share_text : that.activityView.title, // 分享描述
            link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.activityView.banner.length > 0 ? that.activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // that.$emit('shareok')
              // 设置成功
              //   alert('分享给朋友,分享到QQ,设置成功')
            }
          })
          wx.updateTimelineShareData({
            title: '线上展厅 | ' + that.activityView.title, // 分享标题
            link: shareWxLink,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.activityView.banner.length > 0 ? that.activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // 设置成功
              // alert('分享到朋友圈,分享到QQ空间,设置成功')
            }
          })
        })
        wx.onMenuShareTimeline({
          title: '线上展厅 | ' + that.activityView.title, // 分享标题
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.activityView.banner.length > 0 ? that.activityView.banner[0].src : '' , // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.onMenuShareAppMessage({
          title: '线上展厅 | ' + that.activityView.title, // 分享标题
          desc: that.activityView.share_text !== null ? that.activityView.share_text : that.activityView.title, // 分享描述
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.activityView.banner.length > 0 ? that.activityView.banner[0].src : '' ,
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.error(function (res) {
          console.log(res)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .banner-all{
        height: 250px;
    }
    .banner-img{
        width: 100%;
        height: 100%;
    }
    .index-break{
        padding: 10px;
        background-color: #ededed;
    }
.search-container{
    display: flex;
    /*width: 350px;*/
    margin-top: 10px;
    .inp{
        width: 200px;
        border: 1px solid #cccccc;
        height: 28px;
        padding-left: 4px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    .bont1{
        border: 1px solid #0034e8;
        background-color: #0034e8;
        color: #ffffff;
        font-size: 14px;
        line-height: 30px;
        width: 50px;
        height: 30px;
        text-align: center;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    .bont{
        font-size: 13px;
        margin-left: 20px;
        color: #0034e8;
        border: 1px solid #0034e8;
        display: inline-block;
        width: 70px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        margin-top: 0;
    }
}
.ul-bonts{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    div{
        width: 120px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        text-align: center;
        background-color: #ededed;
        /*border: 1px solid #cccccc;*/
        color: #bbb;
    }
    .ul-bonts-left{
        background-color: #ffc000;
        /*border: 1px solid #bc8c00;*/
        color: #ffffff;
    }
    .ul-bonts-right{
        background-color: #ed7d31;
        /*border: 1px solid #ae5e21;*/
        color: #ffffff;
    }
}
    .company-ul{
        margin-top: 10px;
        border-top: 10px solid #ededed;
        color: #383838;
        .company-li{
            padding: 10px 0px 10px 20px;
            display: flex;
            /*height: 100px;*/
            justify-content: space-between;
            border-bottom: 10px solid #ededed;
            .company-li-img{
                width:86px;
                img{
                    width: 100%;
                }
            }
            .company-msg{
                margin-left: 10px;
                width: 200px;
                .title{
                    margin-top: 18px;
                    font-size: 16px;
                    height: 37px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    line-height: 18px;
                }
                .nums{
                    margin-top: 0;
                    display: flex;
                    color: #aaa;
                    font-size: 14px;
                    .icon-3{
                        font-size: 18px;
                    }
                    div:nth-of-type(1){
                        position: relative;
                        top: -2px;
                        margin-right: 10px;
                    }
                }
            }
            .company-icon{
                width: 26px;
                height: 26px;
                margin-top: 30px;
            }
        }
    }
    .img-class{
        text-align: center;
        width: 100%;
        padding-top: 50px;
    }
    .layer-bor{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.4);
        .layer-cont{
            z-index: 99;
            background-color: #ffffff;
            width: 80%;
            padding: 10px 20px;
            margin: 10% auto;
            border-radius: 4px;
            height: 500px;
            overflow-y: auto;
            input{
                width: 100%;
            }
            input::placeholder{
                color: #cccccc;
            }
            .layer-icon{
                float: right;
                font-size: 34px;
            }
            .layer-title{
                margin-top: 10px;
                position: relative;
                top: -14px;
                text-align: center;
                font-size: 15px;
                font-weight: bold;
            }
            .layer-tips{
                font-size: 12px;
                margin-bottom: 10px;
            }
            .inp-bor{
                margin-top: 16px;
                //border-bottom: 1px solid #999;
                .inp-bor-title{
                    font-size: 13px;
                    span{
                        color: #E1293B;
                    }
                }
                .inp-bor-def{

                    color: #333333;
                    margin-top: 4px;
                    font-size: 14px;
                }
                .inp-bor-select{
                    margin: 6px 0;
                }
            }
        }
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 24px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
    .bonts{
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }
    .back-bont{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
    }
</style>
<style>
    *{
        -webkit-user-select: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/company/index.vue